<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Таверна</h3>
		</header>
		<p class="text-center">
			<img src="//iwstatic.g.bsrv.su/resources/images/tavern1.jpg" width="150" height="106" /> <img src="//iwstatic.g.bsrv.su/resources/images/tavern5.jpg" width="150" height="106" />
		</p>
		<p><b>Таверна</b> - в этом строении можно нанять платных юнитов для работы на разных объектах острова. Также можно просматривать рейтинги игроков. Максимальное количество уровней - 10.</p>
		<p><b>Особенности строения:</b></p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisTavern',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>